import React from 'react';
import ReactDOM from 'react-dom';
import './modal.scss'


const Modal = ({isShowing, hide, modalContent, mobileFloating, closeButton}) => isShowing ? ReactDOM.createPortal(
    <React.Fragment>
        <div className="modal-overlay"/>
        <div className={`modal-wrapper flex flex-col items-center ${mobileFloating ? 'justify-center' : 'justify-end'} sm:justify-center`} onClick={hide}
             aria-modal aria-hidden tabIndex={-1} role="dialog">
            <div className={`modal ${mobileFloating ? 'max-h-96 w-11/12' : 'w-full max-h-96'} overflow-auto sm:max-w-xl sm:max-h-96`}
                 onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    {
                        closeButton && (
                            <button type="button" className="modal-close-button" data-dismiss="modal" aria-label="Close"
                                    onClick={hide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        )
                    }
                </div>
                <div>
                    {modalContent}
                </div>
            </div>
        </div>
    </React.Fragment>, document.body
) : null;

export default Modal;
